import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, of } from 'rxjs';

interface Payload{
    communicationType : string,
    title : string,
    content : string,
    url : string,
    language : string
}

@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  private readonly localStorageKey = 'editNotificationData';

  constructor(private http: HttpClient) {}

  private getStoredNotificationData(): any {
    const storedData = localStorage.getItem(this.localStorageKey);
    return storedData ? JSON.parse(storedData) : null;
  }

  private setStoredNotificationData(data: any) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  private clearStoredNotificationData() {
    localStorage.removeItem(this.localStorageKey);
  }

  setNotificationData(data: any) {
    this.setStoredNotificationData(data);
  }

  getNotificationData() {
    return this.getStoredNotificationData();
  }

  clearNotificationData() {
    this.clearStoredNotificationData();
  }
  
  createNotification(payload: Payload) {
    const url = `${environment.host}/promotion/notifications`;  
    return this.http.post<any>(url, payload);
  }

  listNotification(){
    const url = `${environment.host}/promotion/notifications`;
    return this.http.get<any>(url)
  }
  
  deleteNotification(id: string){
    const url = `${environment.host}/promotion/notifications/${id}`;
    return this.http.delete<any>(url)
  }

  getNotificationbyID(id:string){
    const url = `${environment.host}/promotion/notifications/${id}`;
    return this.http.get<any>(url)
  }

  testNotification(id: string, emails: string[]) {
    const url = `${environment.host}/promotion/notifications/${id}/test`;
    return this.http.post<any>(url, emails);
  }

  releaseNotification(id: string){
    const url = `${environment.host}/promotion/notifications/${id}/release`;
    return this.http.post<any>(url,{});
  }

  updateNotification(id: string, requestBody:any) {
    const url = `${environment.host}/promotion/notifications/${id}`;
    return this.http.patch(url, requestBody);
  }
  
}